import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Icon20 } from 'builder/components/Icon'
import { Typography, FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

import { WidgetImage } from '../../widget.styles'

export const Image = styled(WidgetImage)``
export const ProgressActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  ${Media.Phone`
    gap: 8px;
    flex-direction: row;
    justify-content: center;
  `}
`

export const ButtonContainer = styled.button`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 11px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};

  ${Media.Phone`
    width: 100%;
    justify-content: center;
  `}
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}  

  color: ${Colors.Neutral90};
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`

export const ScoreText = styled.p`
  ${Typography.Body}
  ${FontWeights.DemiBold}

  color: ${Colors.Green50};
`
